import { createPagination, createSearchModel } from './model.js';

export default {
  // 搜索
  searchModel: createSearchModel(),
  // 分页
  paginationModel: createPagination(), //paginationModel
  // pageSize存远端管理
  pageSizeRemote: {
    key: 'scm_pageSize',
    value: {},
    needInit: true,
  },

  // 审核状态数量统计
  auditStatusCount: {
    WAIT_AUDIT: 0,
    WAIT_AUDIT_75: 0,
  },

  // 列表加载保留上次渲染索引表示
  listKeepLastRenderIndex: false,

  // 表格数据
  auditTableData: [],
  // 表格选中数据
  auditMultipleSelection: [],
  checksTable: [], // 选中的数据
  // 订单处理页面你当前 tab
  currentTab: null,
  // 标签
  tagList: [],

  // 快捷查询列表
  groupList: [],

  // 字典数据
  dictionaryData: {
    shopList: [], // 店铺数据
    supplierList: [], // 供销商
    expressCompanies: [], // 公司id
    distributorList: [], // 分销商
    customExceptionList: [], // 自定义异常
  },

  // 交易配置
  tradeSetting: {
    orderImageSource: 0,
    showSkuProperties: 0,
    chatConfigs: {},
  },

  // 新版交易配置
  tradeNewSetting: {

  },
  // 列表商品信息展示字段
  goodsInfoShow: {
    key: 'scm_goodsInfoShow',
    value: {
      title: 1, // 商品名称
      skuPropertiesName: 1, // 颜色规格
      mainOuterId: 1, // 款式编码
      outerId: 1, // 商品编码
      platFormTitle: 0, // 平台商品名称
      platSkuPropertiesName: 0, // 平台商品规格
      numIid: 0, // 平台商品ID
      skuId: 0, // 平台商品skuid

      expandAllProd: false, // 展开所有商品
    }
  },
  goodsInfoList: [
    {key: 'title', name: '商品名称'},
    {key: 'skuPropertiesName', name: '颜色规格'},
    {key: 'mainOuterId', name: '款式编码'},
    {key: 'outerId', name: '商品编码'},
    {key: 'platFormTitle', name: '平台商品名称'},
    {key: 'platSkuPropertiesName', name: '平台商品规格'},
    {key: 'numIid', name: '平台商品ID'},
    {key: 'skuId', name: '平台商品skuid'},
  ]
};
